import { Label } from "@monsterindia/global-ui-components";
import { memo } from "react";
import { Controller } from "react-hook-form";

import { LgbtqiaApopControllerType } from "../../../../../../types/apop";
import { ErrorText } from "../../../../common/ErrorText";
import { RadioButton } from "./radioButtons";

type RadioControllerProps = {
  options: { displayName: string; id: string; value: string }[];
} & LgbtqiaApopControllerType;

const RadioController = ({
  name,
  label,
  control,
  errors,
  options,
  setIsUserInput,
}: RadioControllerProps) => {
  return (
    <div className="l1-w-full">
      <Label
        className="!l1-mb-4 l1-flex p-0"
        labelText={label}
        isRequired={true}
      >
        <Controller
          name={name}
          control={control}
          rules={{ required: "This field is required" }}
          render={({ field }) => (
            <>
              <RadioButton
                setIsUserInput={setIsUserInput}
                eventChangeHandler={field.onChange}
                value={field.value}
                options={options}
                name={name}
              />
              {errors[name] && <ErrorText text="This field is required" />}
            </>
          )}
        />
      </Label>
    </div>
  );
};

export default memo(RadioController);
